export default "__VITE_ASSET__60d3f17a__"